import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120sSchK = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Schedule K (Form 1120-S): Income, Deductions & Credits"
          description="Learn how to accurately complete Schedule K (Form 1120-S) to report your S corporation’s income, deductions, credits, and other tax details."
          keywords=""
          canonical="resources/business-tax/schedule-k/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule K</span>
          </span>{' '}
          (Form 1120-S): Comprehensive Summary of S Corporation Income,
          Deductions & Credits
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-k/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule K (Form 1120-S) at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    It summarizes an S corporation's{' '}
                    <span style={{ fontWeight: 600 }}>
                      income, deductions, credits, and other tax items
                    </span>{' '}
                    that are passed through to shareholders and reported on
                    Schedule K-1.
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Who Must Complete:
                        </span>{' '}
                        S corporations filing{' '}
                        <span style={{ fontWeight: 600 }}>Form 1120-S</span>{' '}
                        generally complete Schedule K to report the
                        corporation's total tax items.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span style={{ fontWeight: 600 }}>
                          What It Reports:
                        </span>{' '}
                        Includes{' '}
                        <span style={{ fontWeight: 600 }}>
                          ordinary business income or loss, rental income,
                          interest and dividends, capital gains and losses,
                          deductions, credits, and other separately stated items
                        </span>
                        .
                      </span>
                    </li>
                    <li>
                      <span>
                        <span style={{ fontWeight: 600 }}>
                          Schedule K-1 Connection:
                        </span>{' '}
                        The amounts reported on Schedule K are used to prepare{' '}
                        <span style={{ fontWeight: 600 }}>Schedule K-1</span>,
                        which reports each shareholder's allocated share of the
                        S corporation's tax items.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Schedule K (Form 1120-S)
                      </span>{' '}
                      plays a pivotal role in the{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        S corporation tax filing
                      </Link>{' '}
                      process as it provides a comprehensive summary of the
                      corporation’s financial activities for the tax year. This
                      schedule consolidates the income, deductions, credits, and
                      other tax attributes that affect the shareholders.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      While Form 1120-S shows the overall tax return, Schedule K
                      focuses on summarizing items that flow through to
                      shareholders on Schedule K-1, enabling accurate individual
                      reporting on their tax returns.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Accurately completing Schedule K ensures the IRS receives
                      a full picture of your corporation’s tax attributes and
                      supports transparent, consistent reporting to
                      shareholders.{' '}
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule K (Form 1120-S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#detailed" sx={{ color: '#0202ff' }}>
                          Detailed Breakdown of Schedule K Sections
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must Complete Schedule K?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#deadline" sx={{ color: '#0202ff' }}>
                          Filing Deadlines and Extensions
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Errors and How to Avoid Them
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule K Preparation
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule K (Form 1120-S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule K is often described as the “corporate-wide summary
                  schedule” of your S corporation’s financial and tax items. It
                  includes multiple categories of income, deductions, credits,
                  and adjustments that collectively represent the tax
                  implications of your business activities.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Items reported on Schedule K include but are not limited to:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Ordinary business income or loss:
                    </span>{' '}
                    Net income from the corporation’s main operations after
                    allowable deductions.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Rental income or loss:
                    </span>{' '}
                    Income and expenses related to rental real estate and other
                    rental activities.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Interest and dividend income:{' '}
                    </span>{' '}
                    Including ordinary interest, tax-exempt interest, and
                    dividends, both ordinary and qualified.
                  </li>

                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Capital gains and losses:{' '}
                    </span>{' '}
                    Realized on sales or exchanges of capital assets, separated
                    into short-term and long-term components.
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}> Deductions:</span> Such
                    as Section 179 expense deductions, charitable contributions,
                    and other expenses deductible on the corporate level.
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>Credits:</span> Tax
                    credits earned and available, including foreign tax credits
                    and general business credits.
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>Other items:</span> Such
                    as tax-exempt income, nondeductible expenses, distributions,
                    alternative minimum tax (AMT) items, and foreign
                    transactions.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3, fontWeight: 600 }}>
                  Each item in Schedule K is carefully categorized to inform the
                  IRS and shareholders of their potential tax impact.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="detailed"
                >
                  Detailed Breakdown of Schedule K Sections
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule K summarizes the S corporation's total income,
                  deductions, credits, and other tax items that pass through to
                  shareholders. The corporation reports the total amounts on
                  Schedule K, while each shareholder's allocated share is
                  reported separately on{' '}
                  <Link
                    href="/resources/business-tax/schedule-k-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule K-1
                  </Link>
                  .
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Income (Loss)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports the corporation's taxable income, gains,
                  and losses that pass through to shareholders. Some items are
                  reported separately because they receive different tax
                  treatment at the shareholder level, which includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Ordinary business income (loss)</li>
                  <li>
                    Rental real estate income (loss) and other rental activities
                  </li>
                  <li>Interest income and dividend income</li>
                  <li>Royalty income</li>
                  <li>Short-term and long-term capital gains (or losses)</li>
                  <li>Collectibles gain and unrecaptured Section 1250 gain </li>
                  <li>Section 1231 gains (or losses) </li>
                  <li>Other separately stated income items </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Certain income items require supporting schedules, such as
                  <Link
                    href="/resources/business-tax/form-8825/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 8825
                  </Link>
                  ,{' '}
                  <Link
                    href="/resources/business-tax/form-1120s-schedule-d/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule D (Form 1120-S)
                  </Link>
                  , and{' '}
                  <Link
                    href="/resources/business-tax/form-4797/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4797
                  </Link>
                  . Shareholders generally report their allocated share of these
                  items on their individual tax returns, whether or not the
                  income is distributed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Deductions
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports deductions that must be separately passed
                  through to shareholders instead of being included in ordinary
                  business income. Reporting these items separately allows
                  shareholders to apply the appropriate IRS limitations and
                  deduction rules, which includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Section 179 expense deduction</li>
                  <li>Cash and noncash charitable contributions </li>
                  <li>Investment interest expense </li>
                  <li>Section 59(e)(2) expenditures </li>
                  <li>Other separately stated deductions </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Some deductions require additional supporting forms, such as
                  <strong style={{ fontWeight: 600 }}> Form 4562</strong> for
                  Section 179 deductions or attached statements for other
                  deductible items.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. Credits
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports tax credits earned by the corporation
                  that are allocated to shareholders. Unlike deductions, these
                  credits may directly reduce a shareholder's federal income tax
                  liability if the applicable requirements are met, which
                  includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Low-income housing credits </li>
                  <li>Qualified rehabilitation expenditures </li>
                  <li>Rental real estate credits </li>
                  <li>Other rental credits </li>
                  <li>Biofuel producer credit </li>
                  <li>Other federal tax credits </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Certain credits require supporting forms, including{' '}
                  <strong style={{ fontWeight: 600 }}> Form 3468</strong> and{' '}
                  <strong style={{ fontWeight: 600 }}>Form 6478</strong>,
                  depending on the credit being claimed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  4. International
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports items related to the corporation's
                  international tax activities. If the corporation has foreign
                  income, foreign taxes, or other international tax information,
                  it may be required to attach{' '}
                  <strong style={{ fontWeight: 600 }}>
                    Schedule K-2 (Form 1120-S)
                  </strong>
                  , which includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>International tax items reported on Schedule K-2 </li>
                  <li>Foreign-source income </li>
                  <li>Foreign tax information </li>
                  <li>IRS filing exception for eligible corporations </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Corporations that qualify for the IRS filing exception may
                  check the appropriate box instead of filing Schedule K-2.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  5. Alternative Minimum Tax (AMT) Items
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports adjustments and preference items that
                  shareholders may need when determining Alternative Minimum Tax
                  (AMT). Although the corporate AMT generally does not apply to
                  S corporations, certain AMT-related information must still be
                  passed through to shareholders, which includes
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Post-1986 depreciation adjustments </li>
                  <li>Adjusted gains or losses </li>
                  <li>Depletion adjustments </li>
                  <li>
                    Oil, gas, and geothermal property income and deductions{' '}
                  </li>
                  <li>Other AMT adjustment items </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  These amounts help shareholders determine whether additional
                  AMT calculations are required on their individual returns.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 0,
                    lineHeight: 1.5,
                  }}
                >
                  6. Other Income and Adjustments
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports items that increase or decrease each
                  shareholder's stock or debt basis in the S corporation.
                  Maintaining an accurate basis is important because it
                  determines whether losses are deductible and whether
                  distributions are taxable, which includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Tax-exempt interest income </li>
                  <li>Other tax-exempt income </li>

                  <li>Nondeductible expenses </li>
                  <li>Shareholder distributions </li>
                  <li>Repayment of shareholder loans</li>
                  <li>Foreign taxes paid or accrued </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  These items may not directly affect taxable income but play an
                  important role in calculating each shareholder's basis and
                  future tax consequences.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 0,
                    lineHeight: 1.5,
                  }}
                >
                  7. Other Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports additional tax information shareholders
                  may need when preparing their individual tax returns. These
                  items are reported separately because they may affect various
                  tax calculations or reporting requirements.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Investment income </li>
                  <li>Investment expenses </li>

                  <li>
                    Dividend distributions from accumulated earnings and
                    profits{' '}
                  </li>
                  <li>
                    Other separately stated information required by the IRS{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Supporting statements should be attached whenever additional
                  details are needed.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 0,
                    lineHeight: 1.5,
                  }}
                >
                  8. Reconciliation
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The reconciliation section summarizes the corporation's
                  overall pass-through income or loss by combining the amounts
                  reported throughout Schedule K. It ensures that all income,
                  deductions, and applicable adjustments have been properly
                  reflected before the information is allocated to shareholders.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The reconciliation:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Combines total income reported on{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Lines 1 through 10
                    </strong>{' '}
                  </li>
                  <li>
                    Subtracts deductions reported on{' '}
                    <strong style={{ fontWeight: 600 }}>
                      Lines 11 through 12e
                    </strong>{' '}
                  </li>

                  <li>
                    Subtracts foreign taxes reported on{' '}
                    <strong style={{ fontWeight: 600 }}>Line 16f</strong>
                  </li>
                  <li>
                    Determines the corporation's total pass-through income (or
                    loss) reported to shareholders through Schedule K-1
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This final reconciliation helps verify the accuracy and
                  completeness of the corporation Schedule K reporting before
                  shareholder allocations are made.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must Complete Schedule K?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  All S corporations{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 1120-S
                  </Link>{' '}
                  must complete Schedule K regardless of corporation size or
                  income, as it forms the foundation for shareholder tax
                  reporting.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  How Schedule K Interacts With Schedule K-1 and Other
                  Schedules{' '}
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Schedule K aggregates the corporation’s total financial
                    data.{' '}
                  </li>
                  <li>
                    Schedule K-1 breaks down these totals by shareholder,
                    showing their pro-rata shares. Each shareholder uses their
                    Schedule K-1 to report income and deductions on personal or
                    other tax returns.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Additionally, Schedule K information corresponds and
                  reconciles with other corporate schedules such as:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}> Schedule L:</span> The
                    corporate balance sheet.{' '}
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>Schedule M-1:</span>{' '}
                    Reconciliation of book income with taxable income.{' '}
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>Schedule M-2:</span>{' '}
                    Analysis of retained earnings and accumulated
                    adjustments.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="deadline"
                >
                  Filing Deadlines and Extensions
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule K must be filed{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    alongside Form 1120-S
                  </span>{' '}
                  by the S corporation’s tax filing deadline.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporations </TableCell>
                          <TableCell>Form 1120-S </TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Errors and How to Avoid Them
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Error
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Consequence
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Prevention Tip
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Misreporting income or deductions{' '}
                          </TableCell>
                          <TableCell>
                            IRS penalties and inaccurate taxes
                          </TableCell>
                          <TableCell>
                            Double-check with financial statements and tax rules
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Failure to allocate shares correctly{' '}
                          </TableCell>
                          <TableCell>
                            Shareholder tax under/over reporting{' '}
                          </TableCell>
                          <TableCell>
                            Use precise ownership percentages and reconcile
                            K/K-1
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Omitting foreign or tax-exempt details{' '}
                          </TableCell>
                          <TableCell>
                            Audit risk and compliance issues{' '}
                          </TableCell>
                          <TableCell>
                            Review foreign income and credits carefully
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Missing Schedule K with Form 1120-S{' '}
                          </TableCell>
                          <TableCell>Return rejection or delay </TableCell>
                          <TableCell>
                            Use software or professional review to ensure
                            inclusion
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule K Preparation
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Keep accurate books and records throughout the year,
                    categorizing income and deductions correctly.
                  </li>
                  <li>
                    Coordinate between your accountant and tax preparer to
                    ensure all items are correctly reported.{' '}
                  </li>
                  <li>
                    Use{' '}
                    <Link
                      href="/business-tax/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      TaxZerone’s e-filing platform
                    </Link>{' '}
                    which provides automated validations and Schedule K
                    inclusion to reduce errors.{' '}
                  </li>
                  <li>
                    Review shareholder agreements to verify proper income
                    allocation and reporting compliance.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What does Schedule K report?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule K consolidates your S corporation’s income,
                  deductions, credits, and other tax items into a summary for
                  IRS and shareholder reporting.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Is Schedule K mandatory?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, all S corporations filing Form 1120-S must complete and
                  file Schedule K.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. How do shareholders use Schedule K?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Shareholders use Schedule K to understand the corporation’s
                  total tax items, then refer to their Schedule K-1 for
                  individual reporting.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Can Schedule K be filed electronically?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, electronic filing platforms like TaxZerone include
                  Schedule K in the full Form 1120-S e-file submission.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What happens if Schedule K is incorrect or missing?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS may assess penalties and shareholder tax reporting may
                  be inaccurate, increasing audit risk.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule K Using TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure your S corporation’s financial summary is correctly
              reported and IRS-compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sschk`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120sSchK;
